import { defineMessage } from 'magpie-lib/models';
import * as t from 'ts-schema';
// NOTE: Messasges in this file are intended for use with `magpie-lib`

const commons = {
  platformName: t.string
};
const setIsOpen = defineMessage({
  type: 'set-is-open',
  payloadSchema: t.object(Object.assign({
    name: t.string,
    value: t.boolean
  }, commons))
});
export const getStateReply = defineMessage({
  type: 'get-state-reply',
  payloadSchema: t.object({
    isLoaded: t.boolean,
    isOpen: t.boolean,
    isReady: t.boolean,
    isDisabled: t.boolean,
    isFullscreenMode: t.boolean,
    style: t.custom('CSSProperties', value => typeof value === 'object')
  })
});
const getState = defineMessage({
  type: 'get-state',
  payloadSchema: t.object(Object.assign({
    name: t.string
  }, commons)),
  reply: getStateReply
});
const getPropsReply = defineMessage({
  type: 'get-props-reply',
  payloadSchema: t.object({})
});
const getProps = defineMessage({
  type: 'get-props',
  payloadSchema: t.object(Object.assign({
    name: t.string
  }, commons)),
  reply: getPropsReply
});
const setProps = defineMessage({
  type: 'set-props',
  payloadSchema: t.object(Object.assign({
    name: t.string,
    value: t.record(t.string, t.any)
  }, commons))
});
export const setIsLoadedReply = defineMessage({
  type: 'set-is-loaded-reply'
});
const setIsLoaded = defineMessage({
  type: 'load-component',
  payloadSchema: t.object(Object.assign({
    name: t.string,
    value: t.boolean
  }, commons)),
  reply: setIsLoadedReply
});
const invokeFunctionReply = defineMessage({
  type: 'invoke-function-reply'
});
const invokeFunction = defineMessage({
  type: 'invoke-function',
  payloadSchema: t.object(Object.assign({
    name: t.string,
    fnName: t.string,
    args: t.any
  }, commons)),
  reply: invokeFunctionReply
});
export const ncRemoteOperations = {
  setIsOpen,
  getState,
  setProps,
  setIsLoaded,
  getProps,
  invokeFunction
};
export const ncRemoteOperationsReplies = {
  getStateReply,
  getPropsReply,
  setIsLoadedReply,
  invokeFunctionReply
};